import React, { Component } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import business from "../../../Assets/Images/Business_with-img.svg";
import learn from "../../../Assets/Images/learn.svg";
import './Style.scss'



export class Choose extends Component {
  render() {
    return (
      <>
        <section className="chooseSectionContainer">
          <Container className="chooseSection">
            <Row className="chooseSectionRows chooseSectionRowsOuter">
              <Col>
                <div className="innerCard card1">
                  <Container>
                    <Row className="chooseSectionRows">
                      <Col lg={10} md={8} sm={12}>
                        <div className="txtContainer">
                          <h3 className="title">Business With Us</h3>
                          <h6 className="subTitle">Ready to partner?</h6>
                          <p className="disc">
                            Get a share of the brokerage from each trade your
                            referred client makes & Earn incentives through
                            referrals, the more you refer the more you earn.
                          </p>
                          <Button>Register Now</Button>
                        </div>
                      </Col>
                      <Col lg={2} md={4} sm={12}>
                        <div className="imgContainer">
                          <img
                            src={business}
                            alt="Business OPG Securities"
                            className="ImgContainer"
                            width={100}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
              <Col>
                <div className="innerCard card2">
                  <Container>
                    <Row className="chooseSectionRows">
                      <Col lg={10} md={8} sm={12}>
                        <div className="txtContainer">
                          <h3 className="title">Learn & Invest</h3>
                          <h6 className="subTitle">
                            Your financial journey starts here
                          </h6>
                          <p className="disc">
                            Investing can be complicated — that’s why we’re
                            here. From beginners’ guides to timely features,
                            explore articles that make finance a little more
                            understandable.
                          </p>
                          <div className="btns">
                            <Button>OPG Blogs</Button>
                            <Button>OPG Research</Button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={2} md={4} sm={12}>
                        <div className="imgContainer">
                          <img
                            src={learn}
                            alt="Learn & Invest OPG Securities"
                            className="ImgContainer"
                            width={100}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default Choose;
